import React, { useEffect, createElement } from 'react';
import { KidsTaekwondoHeroInfo } from './kids-taekwondo/KidsTaekwondoHeroInfo';
import { KidsTaekwondoHeroForm } from './kids-taekwondo/KidsTaekwondoHeroForm';
import { KidsTaekwondoBridge } from './kids-taekwondo/KidsTaekwondoBridge';
import { KidsTaekwondoBenefits } from './kids-taekwondo/KidsTaekwondoBenefits';
import { KidsTaekwondoNarrative } from './kids-taekwondo/KidsTaekwondoNarrative';
import { KidsTaekwondoWhatYouLearn } from './kids-taekwondo/KidsTaekwondoWhatYouLearn';
import { KidsTaekwondoReviews } from './kids-taekwondo/KidsTaekwondoReviews';
import { KidsTaekwondoScheduleLocation } from './kids-taekwondo/KidsTaekwondoScheduleLocation';
import { KidsTaekwondoFAQHeader } from './kids-taekwondo/KidsTaekwondoFAQHeader';
import { KidsTaekwondoFAQQuestions } from './kids-taekwondo/KidsTaekwondoFAQQuestions';
import { KidsTaekwondoFAQActions } from './kids-taekwondo/KidsTaekwondoFAQActions';
import { KidsTaekwondoRelatedLinks } from './kids-taekwondo/KidsTaekwondoRelatedLinks';
import { KidsTaekwondoFinalCTA } from './kids-taekwondo/KidsTaekwondoFinalCTA';
export function KidsTaekwondo() {
  useEffect(() => {
    document.title = 'Kids Taekwondo Classes Farmington Hills | Storm Taekwondo';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Kids Taekwondo classes in Farmington Hills that build confidence, focus and discipline. Ages 3 and up. Claim a free week at Storm Taekwondo.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Kids Taekwondo classes in Farmington Hills that build confidence, focus and discipline. Ages 3 and up. Claim a free week at Storm Taekwondo.';
      document.head.appendChild(meta);
    }
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-2340">
      <section className="relative bg-ink pt-12 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-2341">
        <div className="absolute inset-0 opacity-20" data-id="element-2342">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.stormtaekwondo.com/uploaded/images/Redesigne%202024/Discover%20the%20Perfect%20Program%20for%20Your%20Mini%20Trooper.png" alt="Taekwondo Background" className="block w-full h-full object-cover" data-id="element-2343" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-2344" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2345">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-2346">
            <KidsTaekwondoHeroInfo data-id="element-2347" />

            <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto" data-id="element-2348">
              <KidsTaekwondoHeroForm data-id="element-2349" />
            </div>
          </div>
        </div>
      </section>
      <KidsTaekwondoBridge data-id="element-2350" />
      <KidsTaekwondoBenefits data-id="element-2351" />
      <KidsTaekwondoNarrative data-id="element-2352" />
      <KidsTaekwondoWhatYouLearn data-id="element-2353" />
      <KidsTaekwondoReviews data-id="element-2354" />
      <KidsTaekwondoScheduleLocation data-id="element-2355" />
      <section className="py-24 bg-off-white" data-id="element-2356">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2357">
          <KidsTaekwondoFAQHeader data-id="element-2358" />
          <KidsTaekwondoFAQQuestions data-id="element-2359" />
          <KidsTaekwondoFAQActions data-id="element-2360" />
        </div>
      </section>
      <KidsTaekwondoRelatedLinks data-id="element-2361" />
      <KidsTaekwondoFinalCTA data-id="element-2362" />
    </div>;
}